var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.113 35.0001C17.4056 35.5068 17.8264 35.9275 18.3331 36.22C18.8398 36.5126 19.4146 36.6666 19.9997 36.6666C20.5848 36.6666 21.1596 36.5126 21.6663 36.22C22.173 35.9275 22.5938 35.5068 22.8863 35.0001M28.333 28.3334H6.66634C6.34334 28.3335 6.02727 28.2398 5.75656 28.0636C5.48586 27.8874 5.27218 27.6363 5.14153 27.3409C5.01087 27.0455 4.96886 26.7185 5.02061 26.3997C5.07236 26.0809 5.21563 25.784 5.43301 25.5451C7.64967 23.2601 9.99967 20.8317 9.99967 13.3334C9.99943 12.3497 10.1443 11.3714 10.4297 10.4301M3.33301 3.3334L36.6663 36.6667M14.4463 5.01673C15.9521 4.0112 17.7027 3.43339 19.5112 3.34495C21.3197 3.2565 23.1183 3.66076 24.7151 4.51456C26.3118 5.36837 27.6468 6.63968 28.5775 8.19284C29.5082 9.746 29.9997 11.5227 29.9997 13.3334C29.9997 17.8117 31.283 21.0884 32.8447 23.4167",
    stroke: "#245775",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.dab31d8a720fb6c5fd60384052649b90.svg";
export { ForwardRef as ReactComponent };